import { b64urlenc } from "./b64urlenc";
export const rndstr = (len = 32) => {
    const bytes = new Uint8Array(len);
    crypto.getRandomValues(bytes);
    return b64urlenc(bytes.buffer);
};
